export default __webpack_public_path__ + "static/media/LandingPageFour.93f42f34.png";